import {
  gql 
} from "@apollo/client";

export const GET_PRODUCT_FILTERS_BY_CATEGORY = gql`
    query getProductFiltersByCategory(
        $categoryIdFilter: FilterEqualTypeInput!
        # $productColor: FilterEqualTypeInput
    ) {
        products(
            filter: {
                category_uid: $categoryIdFilter
            }
        ) {
            aggregations {
                label
                count
                attribute_code
                options {
                    label
                    value
                    count
                    swatch_data {
                        value
                    }
                }
                position
            }
        }
    }
`;

export const GET_CATEGORY_CONTENT = gql`
    query getCategoryData($id: String!) {
        categories(filters: { category_uid: { in: [$id] } }) {
            # eslint-disable-next-line @graphql-eslint/require-id-when-available
            items {
                id
                uid
                name
                description
                url_key
                url_path
                category_image
            }
        }
    }
`

export const GET_CATEGORY_AVAILABLE_SORT_METHODS = gql`
    query getCategoryAvailableSortMethods(
        $categoryIdFilter: FilterEqualTypeInput!
    ) {
        products(filter: { category_uid: $categoryIdFilter }) {
            sort_fields {
                options {
                    label
                    value
                }
            }
        }
    }
`

export const GET_CURRENCY = gql`
    query getCurrencyData {
        currency {
            current_currency_code @client
            default_display_currency_code
            available_currency_codes
        }
    }
`

export default {
  getCurrencyQuery: GET_CURRENCY,
  getCategoryContentQuery: GET_CATEGORY_CONTENT,
  getProductFiltersByCategoryQuery: GET_PRODUCT_FILTERS_BY_CATEGORY,
  getCategoryAvailableSortMethodsQuery: GET_CATEGORY_AVAILABLE_SORT_METHODS
};
